import { render, staticRenderFns } from "./SubsectionTags.vue?vue&type=template&id=1aea388a&scoped=true"
import script from "./SubsectionTags.vue?vue&type=script&lang=js"
export * from "./SubsectionTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aea388a",
  null
  
)

export default component.exports